import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Toaster } from "@/components/ui/toaster";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import TeamPage from "@/pages/TeamPage";
import ProfessionalsPage from "@/pages/ProfessionalsPage";
import ServicesPage from "@/pages/ServicesPage";
import SettingsPage from "@/pages/SettingsPage";
import ProfilePage from "@/pages/ProfilePage";
import AgendaPage from "@/pages/AgendaPage";
import PatientsPage from "@/pages/PatientsPage";
import PatientProfilePage from "@/pages/PatientProfilePage";
import TreatmentDetailPage from "@/pages/TreatmentDetailPage";
import FollowUpsPage from "@/pages/FollowUpsPage";
import PublicBookingPage from "@/pages/PublicBookingPage";
import PublicBookingNotFound from "@/pages/PublicBookingNotFound";
import LandingPage from "@/pages/LandingPage";
import InventoryPage from "@/pages/InventoryPage";
import PaymentsPage from "@/pages/PaymentsPage";
import ReportsPage from "@/pages/ReportsPage";
import ConversationsPage from "@/pages/ConversationsPage";
import TemplatesPage from "@/pages/TemplatesPage";
import AutoMessagesPage from "@/pages/AutoMessagesPage";
import AgentSettingsPage from "@/pages/AgentSettingsPage";
import PlatformAdminPage from "@/pages/PlatformAdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { CLINIC_ROLES } from "@/lib/access";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/reservas" element={<PublicBookingNotFound />} />
            <Route path="/reservas/:slug" element={<PublicBookingPage />} />
            <Route path="/plataforma" element={<PlatformAdminPage />} />
            {/* Fix L (2026-09-25): politica de privacidad publica, exigida por Meta */}
            <Route path="/privacidad" element={<PrivacyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              {/* Fix T (2026-10-13): estas paginas son de la clinica; quien no es de la clinica va a su pagina de inicio */}
              <Route path="/dashboard" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><DashboardPage /></ProtectedRoute>} />
              <Route path="/servicios" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><ServicesPage /></ProtectedRoute>} />
              <Route path="/perfil" element={<ProfilePage />} />

              <Route path="/agenda" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><AgendaPage /></ProtectedRoute>} />
              <Route path="/pacientes" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><PatientsPage /></ProtectedRoute>} />
              <Route path="/pacientes/:patientId" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><PatientProfilePage /></ProtectedRoute>} />
              <Route path="/pacientes/:patientId/tratamientos/:treatmentId" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><TreatmentDetailPage /></ProtectedRoute>} />
              <Route path="/seguimiento" element={<ProtectedRoute allowedRoles={CLINIC_ROLES}><FollowUpsPage /></ProtectedRoute>} />
              <Route path="/inventario" element={<ProtectedRoute allowedRoles={["admin"]} area="inventory"><InventoryPage /></ProtectedRoute>} />
              <Route path="/pagos" element={<ProtectedRoute allowedRoles={["admin", "professional"]} area="payments"><PaymentsPage /></ProtectedRoute>} />
              <Route path="/reportes" element={<ProtectedRoute allowedRoles={["admin", "professional"]} area="reports"><ReportsPage /></ProtectedRoute>} />
              <Route path="/conversaciones" element={<ProtectedRoute allowedRoles={["admin", "reception"]}><ConversationsPage /></ProtectedRoute>} />
              <Route path="/conversaciones/plantillas" element={<ProtectedRoute allowedRoles={["admin", "reception"]}><TemplatesPage /></ProtectedRoute>} />
              {/* Fix AN (2026-10-23): mensajes automaticos de WhatsApp (solo admin) */}
              <Route path="/conversaciones/automaticos" element={<ProtectedRoute allowedRoles={["admin"]}><AutoMessagesPage /></ProtectedRoute>} />
              <Route path="/agente" element={<ProtectedRoute allowedRoles={["admin"]}><AgentSettingsPage /></ProtectedRoute>} />

              <Route path="/equipo" element={<ProtectedRoute allowedRoles={["admin"]}><TeamPage /></ProtectedRoute>} />
              <Route path="/profesionales" element={<ProtectedRoute allowedRoles={["admin"]}><ProfessionalsPage /></ProtectedRoute>} />
              <Route path="/configuracion" element={<ProtectedRoute allowedRoles={["admin"]}><SettingsPage /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
